import { Component } from 'preact'
import cx from 'classnames'

import CollapsibleSection from '../collapsible-section'
import GridSelect from '../grid-select'
import SelectGroup from '../select-group'
import Separator from '../separator'
import ActionButton from '../../action-button'
import s from './upgrade-section.sass'
import gs from '../generic-sign-up.sass'
import GymCardV2 from '../../gym-card-v2'
import { richTextToMarkdown } from '../../../helpers/cms'
import Markdown from 'preact-markdown'
import { purchaseFunnelUpgradeSelection } from '../../../helpers/analytics'

export const GridSelectWithFooter = ({
  children,
  ...rest
}) => (
  <div>
    <GridSelect {...rest} />
    <div className={s.footerContainer}>{children}</div>
  </div>
)

export default class UpgradeSection extends Component {
  handleOnInput (value) {
    this.props.onInput(value)
    purchaseFunnelUpgradeSelection(value)
  }

  render ({
    onInput,
    title,
    description,
    inputs,
    value,
    optOut,
    setSidebar,
    ...rest
  }) {
    const noItems = `--noItems: ${Array.isArray(inputs) ? inputs.length : 0}`
    const markDownDescription = description && richTextToMarkdown(description)

    return (
      <CollapsibleSection
        className={s.upgradeSection}
        {...rest}
      >
        <Separator className={s.signUpSeparator} />

        <div className={gs.darkBackground}>
          <div className={cx(s.content, gs.content)}>
            <h2>{title}</h2>
            <p className={gs.sectionDescription}><Markdown markdown={markDownDescription || ''} /></p>

            <SelectGroup
              className={s.gridSelect}
              style={noItems}
              type='radio'
              value={value}
              onChange={(value) => this.handleOnInput(value)}
            >
              {inputs.map((input, key) => {
                const card = <GymCardV2 color={input.cardColor.toLowerCase()} text={input.title} />

                return ( // Remove the name from the input so it doesn't display ontop of the backdrop.
                  <GridSelectWithFooter key={key} backdrop={card} value={input.id} className={s.cardEffect}>
                    <div className={s.footer}>+{input.priceDifferenceSEK}kr/mån</div>
                    <div className={s.footer}>
                      <button
                        className={s.readMore}
                        onClick={() => setSidebar(
                          'info', // Route
                          null, // title
                          {
                            hero: card,
                            title: title,
                            text: richTextToMarkdown(input.description)
                          }, // data
                          'black', // text color
                          ['fadeIn'], // routeModifier
                          false // removeCloseButton
                        )}
                      >
                          Läs mer
                      </button>
                    </div>
                  </GridSelectWithFooter>
                )
              })}
            </SelectGroup>

            <ActionButton className={s.optOut} label='Nej tack' gray onClick={() => this.handleOnInput()} />
          </div>
        </div>
      </CollapsibleSection>
    )
  }
}



// WEBPACK FOOTER //
// ./components/signup-flow/step-wizard/upgrade-section.js